/* LUXEDORE — showcase sections (frosted cards, molecule cards): the dot indicator under a
   row of cards that scrolls sideways, and the ripple that runs through a molecule's atoms
   as its card comes into view. On computers the cards sit side by side; there every
   molecule ripples once when the band scrolls into view. Off for reduced motion. */
(function () {
  if (window.lxShowcaseBound) return;
  window.lxShowcaseBound = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ripple(card, delay) {
    if (reduce || !card) return;
    var svg = card.querySelector('.lxs-mol');
    if (!svg) return;
    setTimeout(function () {
      svg.classList.remove('is-on');
      void svg.getBoundingClientRect();
      svg.classList.add('is-on');
    }, delay || 0);
  }

  function initRow(row) {
    if (row.dataset.lxsReady) return;
    row.dataset.lxsReady = '1';
    var cards = Array.prototype.slice.call(row.children);
    var pager = row.parentElement.querySelector('[data-lxs-pager]');
    var ripples = row.hasAttribute('data-lxs-ripple');
    var buttons = [];
    var scrolls = function () { return row.scrollWidth > row.clientWidth + 2; };

    function current() {
      var start = row.getBoundingClientRect().left + (parseFloat(getComputedStyle(row).paddingLeft) || 0);
      var best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - start); if (d < bestDist) { bestDist = d; best = i; } });
      return best;
    }
    function mark(i) { buttons.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }

    if (pager && cards.length > 1) {
      pager.innerHTML = '';
      cards.forEach(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.tabIndex = -1;
        b.setAttribute('aria-label', 'Card ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () {
          var left = row.scrollLeft + card.getBoundingClientRect().left - row.getBoundingClientRect().left - (parseFloat(getComputedStyle(row).paddingLeft) || 0);
          row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        });
        pager.appendChild(b);
        buttons.push(b);
      });
      mark(0);
    }

    var last = 0, ticking = false;
    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = current();
        mark(i);
        if (ripples && i !== last) ripple(cards[i]);
        last = i;
      });
    }, { passive: true });

    if (ripples && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (scrolls()) ripple(cards[current()]);
          else cards.forEach(function (c, i) { ripple(c, i * 160); });
          io.disconnect();
        });
      }, { threshold: 0.4 });
      io.observe(row);
    }
  }

  function init(scope) { (scope || document).querySelectorAll('[data-lxs-row]').forEach(initRow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
